module.exports = __webpack_public_path__ + "img/logo.2d21bbf1.png";